import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';

// Поля формы для создания/редактирования отзыва
export const FEEDBACK_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'subject',
    label: 'Тема обращения',
    type: EFieldType.input,
    required: true,
    placeholder: 'Введите тему обращения...',
  },
  {
    name: 'text',
    label: 'Текст обращения',
    type: EFieldType.textarea,
    required: true,
    placeholder: 'Введите текст обращения...',
  },
] as const;

// Конфигурация колонок таблицы отзывов
export const FEEDBACK_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Тема',
    type: EFieldType.input,
    dataIndex: 'subject',
  },
  {
    title: 'Сообщение',
    type: EFieldType.input,
    dataIndex: 'text',
  },
  {
    title: 'Имя пользователя',
    type: EFieldType.input,
    dataIndex: 'ownerName',
  },
  {
    title: 'Компания',
    type: EFieldType.input,
    dataIndex: 'company',
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
  },
  {
    title: 'Дата обновления',
    type: EFieldType.dateTime,
    dataIndex: 'updatedAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
  },
];
